module.exports = __webpack_public_path__ + "img/Jump Casting3.91b4befa.jpg";